import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57f2b71c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chip" }

import { computed, inject, onMounted } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment-timezone';
import {
  Report,
  Section,
  Type,
  Item,
  Note,
  DepositoryDeduction,
  Room,
  Photo,
  Dictionary,
  DictionaryRoom,
} from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Deductions',
  props: {
  item: { type: Item },
  note:{ type: Note, required: true},
  noteIndex: { type: Number},
},
  setup(__props) {

const actProperty: any = inject('actProperty');

const props = __props;

const store = useStore();
const report = computed(() => store.getters['reports/current'] as Report);
const dictionary = computed(() => store.getters['dictionary/current'] as Dictionary);
const itemNumber = store.getters['reports/itemNumber'];

const roomIndex = inject<number>('roomIndex');
const sectionIndex = inject<number>('sectionIndex');
const typeIndex = inject<number>('typeIndex');
const typeName = inject<string>('typeName');
const typeSlug = inject<string>('typeSlug');
const itemIndex = inject<number>('itemIndex');

const setReportDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('reports/setReportDeepWithoutCounting', payload);
};

const room = computed(() => {
  let r = new Room();
  if (roomIndex !== undefined && report.value?.rooms) {
    r = report.value.rooms[roomIndex];
  }
  return r;
});

const section = computed(() => {
  let s = new Section();
  if (room.value && sectionIndex !== undefined) {
    s = room.value.sections[sectionIndex];
  }
  return s;
});

const type = computed(() => {
  let t = new Type();
  if (section.value && typeIndex !== undefined) {
    t = section.value.types[typeIndex];
  }
  return t;
});

const deductions = computed(() => {
  return props.note?.depositoryDeductions || [];
});

const isCategoryFourRoom = () => {
  let currentRoomType = room.value.type;
  let found = dictionary.value.rooms.findIndex(
    (dr: DictionaryRoom) => dr.category === 4 && dr.slug === currentRoomType
  );
  return found >= 0;
};

// Logic inside mounted lifecycle hook
onMounted(() => {
  let liabilityflags: string[] = ["CLN", "TT", "STTA", "CLR", "INF"];
    let liabilityindex = -1;
    if (props.note?.responsibility?.length) {
      liabilityindex = props.note?.responsibility?.findIndex((l: string) => {
        let i: number = liabilityflags.indexOf(l);
        return i >= 0;
      });
    }
    if (liabilityindex < 0) {
      // There is no liability selected
      // delete any uncommitted deductions
      setReportDeep({
        path: `rooms[${roomIndex}].sections[${sectionIndex}].types[${typeIndex}].items[${itemIndex}].condition.out.notes[${props.noteIndex}].depositoryDeductions`,
        data: [],
      });
    } else if (isCategoryFourRoom()) {
      ensureDeduction("GARDENING");
    } else {
      props.note?.responsibility?.forEach((responsibility: string) => {
        switch (responsibility) {
          case "CLN":
            ensureDeduction("CLEANING");
            break;
          case "TT":
          case "STTA":
            // If section is ceiling, wall and type is decore
            // or if section is woodwork
            // create REDECORATION type of deduction
            let sectionName = section.value?.name;
            let typeName = type.value?.name;
            if (
              ((sectionName === "Ceiling" || sectionName === "Wall") &&
                typeName === "Décor") ||
              sectionName === "Woodwork"
            ) {
              ensureDeduction("REDECORATION");
            } else {
              ensureDeduction("DAMAGE");
            }
            break;
          case "CLR":
          case "INF":
            ensureDeduction("OTHER");
            break;
        }
      });
    }
});

const ensureDeduction = (deductiontype: string) => {
  if (!props.note?.depositoryDeductions) props.note!.depositoryDeductions = [];
    let index: number | undefined = props.note?.depositoryDeductions?.findIndex(
      (deduction: DepositoryDeduction) => deduction.type === deductiontype
    );

    let existingdeduction: DepositoryDeduction | undefined = undefined;
    let deduction: DepositoryDeduction = new DepositoryDeduction();
    if (index && index >= 0) {
      deduction = props.note!.depositoryDeductions[index];
      existingdeduction = deduction;
      props.note!.depositoryDeductions.splice(index, 1);
    }
    props.note!.depositoryDeductions.push(deduction);

    deduction.name = "";
    if (room.value?.name) deduction.name = room.value.name;
    if (section.value?.name)
      deduction.name = `${deduction.name}-${section.value?.name}`;
    if (type.value?.name)
      deduction.name = `${deduction.name}-${type.value?.name}`;
    if (props.item?.name)
      deduction.name = `${deduction.name}-${props.item?.name}`;
    if (props.item?.colour)
      deduction.name = `${deduction.name}-${props.item?.colour}`;

    deduction.description = props.note!.note;
    deduction.type = deductiontype;
    deduction.externalCreationTime = moment()
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    let reportref: number = itemNumber(props.item);
    if (reportref) deduction.checkoutReportRef = `${reportref}`;
    if (props.item?.condition?.out?.photos?.length)
      deduction.evidenceUrls = props.item?.condition?.out?.photos?.map(
        (photo: Photo) => actProperty.s3Origin(photo.src)
      );

    if (!existingdeduction || !deduction.equals(existingdeduction)) {
      setReportDeep({
        path: `rooms[${roomIndex}].sections[${sectionIndex}].types[${typeIndex}].items[${itemIndex}].condition.out.notes[${props.noteIndex}].depositoryDeductions`,
        data: props.note!.depositoryDeductions,
      });
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deductions.value, (deduction, $deductionIndex) => {
      return (_openBlock(), _createElementBlock("div", { key: $deductionIndex }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["chip-head", { committed: deduction.externalId }])
          }, _toDisplayString(deduction.type[0]), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["chip-content", { 'committed-text': deduction.externalId }])
          }, _toDisplayString(deduction.type), 3)
        ])
      ]))
    }), 128))
  ]))
}
}

})